import { v4 as uuid } from 'uuid';
export const label = {
  Film_Title: 'Title Name',
  Film_Year: 'Year of Release/Production',
  'A+M/Pristine': 'Level of restoration',
  Vendor: 'Report Prepared by (Vendor Side)',
  UCCID: 'Film ID (UCC ID)',
  Type: 'Type of Film',
  'Supervisor Comments': 'NFHM QC Supervisor Comments',
  'Supervisor Name': 'NFHM QC Supervisor Name',
  'Checking Date': 'QC Report Checking Date',
  'Asset ID': 'Film Element with Asset ID',
  'Delivery Format/Medium': 'Delivery Format/Medium Resolution',
  'Vendor Restoration QC Report Checking Date': 'QC Report Checking Date',
  'NFHM QC Restoration Report Checking Date': 'QC Report Checking Date',
  'Vendor Restoration QC Supervisor Name':
    'Vendor Restoration QC Supervisor Name and Signature',
  'NFHM QC Restoration Supervisor Name and Signature':
    'NFHM QC Supervisor Name and Signature',
    'Resolution Scanned': 'Resolution',
    // 'Bit Depth':'Bit rate'
};

//picture vendor table
export const pictureVendor = [
  'Film_Title',
  'Film_Year',
  'Language',
  'A+M/Pristine',
  'Vendor',
  'UCCID',
  'Director',
  'Length-Meters/Feet (as per CBFC)',
  'Report Date',
  'Type',
];
//a-summary table
export const aSummary = [
  'Resolution Scanned',
  'Input Format/Medium',
  'Film_Title',
  'Film Type',
  'Bit Depth',
  'Asset ID',
  'Rescan Used',
  'Single Frame Size',
  'Bit rate',
  'Delivery Format/Medium',
  'Film Scanning Type',
  'Total Frames',
  'Total Reels',
];
export const aSummaryResto = [
  'Resolution Scanned',
  'Input Format/Medium',
  'Film Type',  
  'Asset ID',
  'Rescan Used',
  'Restoration Software used',
  'Single Frame Size',
  'Bit Depth',
  'Delivery Format/Medium',
  'Total Frames',
  'Total Reels',
  'Aspect Ratio',
];
//frame details
export const frameDetails = [
  'Total Frames',
  'Duration (Min)',
  'Duration (Hrs)',
];
//summary
export const summaryIndex = ['Summary'];
//supervisor details
export const supervisorIndices = [
  'Vendor Restoration QC Supervisor Name',
  'Vendor Restoration QC Report Checking Date',
  'Supervisor Comments',
  'Supervisor Name',
  'Checking Date',
];
export const supervisorIndicesResto = [
  'Vendor Restoration QC Supervisor Name',
  'Vendor Restoration QC Report Checking Date',
  'NFHM QC Restoration Supervisor Name and Signature',
  'NFHM QC Restoration Report Checking Date',
];

export const Reel_AnaylsisValidation = [
  ...pictureVendor,
  ...aSummary,
  ...summaryIndex,
  ...frameDetails,
  ...supervisorIndices
];

export const Restoration_Validation = [
  ...pictureVendor,
  ...aSummaryResto,
  ...supervisorIndicesResto
]

export const elementObject = {
  elementId: uuid(),
  elementName: "",
  elementValue: "",
  elementIndex: 0,
  elementType: "TextBox",
  templateElementId: uuid(),
  parentId: "",
  hasChild: false,
  enableByDefault: false,
  options: []
}